export default __webpack_public_path__ + "static/gallery11-e8dfdf2e3e338a72f6e61f6cc9859121.png";